import { FC } from 'react';

type ErrorBody = {
  sendQuery: string;
  errorMessages: Record<string, string>;
};

const ErrorBody: FC<ErrorBody> = ({ errorMessages, sendQuery }: ErrorBody) => (
  <div className="PowerQueries__ErrorContainer">
    <h3 className="PowerQueries__ErrorHeader">One or more fields in the request are invalid</h3>
    <div className="PowerQueries__ErrorMessage">↳{errorMessages?.message}</div>
    <div className="PowerQueries__ErrorString__Container">
      <code className="PowerQueries__ErrorString__Content">
        {sendQuery?.slice(0, parseInt(errorMessages?.errorPosition, 10))}
        <span className="PowerQueries__ErrorFragment">
          {sendQuery?.slice(
            parseInt(errorMessages?.errorPosition, 10),
            parseInt(errorMessages?.errorPosition, 10) + parseInt(errorMessages?.errorLength, 10),
          )}
        </span>
        {sendQuery?.slice(parseInt(errorMessages?.errorPosition, 10) + parseInt(errorMessages?.errorLength, 10))}
      </code>
    </div>
  </div>
);

export default ErrorBody;
